export enum Axes {
  X = 'x',
  Y = 'y',
  All = 'all',
}

export enum Movement {
  Regular = 'regular',
  Inverted = 'inverted',
}

export interface DraggingStart {
  startingX: number;
  startingY: number;
  startingWidth: number;
  startingHeight: number;
  axis: Axes; // x, y or all
  movement: Movement;
  shouldMaintainAspectRatio?: boolean;
  latestHeight?: number;
  latestWidth?: number;
  resizeHandle?: string;
}
